import { combineReducers } from 'redux'

import { accountProfile } from './account'

export const accountReducer = combineReducers({
  accountProfile
})
